import { TransactionLogResponseModel } from '@/models/transaction-log';
import { Avatar, Col, Modal, Row, Tag } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { TransactionStatus } from '../../../../../models/enums';
import DateUtils from '../../../../../utils/date.utils';
import './trans-log-component.scss';

interface LogProps {
  log: TransactionLogResponseModel;
}

function TransactionLogComponent(props: LogProps) {
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(false);

  const handleTitleClick = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const statusColors: { [key in TransactionStatus]: string } = {
    [TransactionStatus.Success]: 'rgb(73 125 199)',
    [TransactionStatus.Error]: 'rgb(217 73 84)',
    [TransactionStatus.InProgress]: 'orange',
    [TransactionStatus.None]: 'black', // Handle all enum values
  };

  const colorItem = statusColors[props.log.logStatus];

  const getColorByHttpMethod = (httpMethod: TransactionStatus): string => {
    switch (httpMethod) {
      case TransactionStatus.Success:
        return 'green';
      case TransactionStatus.Error:
        return 'red';
      case TransactionStatus.InProgress:
        return 'orange';
      default:
        return 'black';
    }
  };

  const getLogStatusTitle = (httpMethod: TransactionStatus): string => {
    switch (httpMethod) {
      case TransactionStatus.Success:
        return 'Success';
      case TransactionStatus.Error:
        return 'Failed';
      case TransactionStatus.InProgress:
        return 'InProgress';
      default:
        return 'None';
    }
  };

  return (
    <>
      <Link
        to="#"
        onClick={handleTitleClick}>
        <Row className="log-component-container">
          <Col span={2}>
            <Avatar
              className="log-icon"
              size={40}
              style={{ backgroundColor: colorItem,  marginRight: '7px' }}
              icon={<i className="icon-send"></i>}
            />
          </Col>
          <Col span={18}>
            <Row className="display-container">
              <Col
                span={24}
                className="action-title"  style={{ color: colorItem }}>
                {props.log.transactionId}
              </Col>
              <Col
                span={24}
                className="details-log">
                <span>Sender : {props.log.sender}</span>
                <span>Receiver: {props.log.receiver}</span>
              </Col>
            </Row>
          </Col>
          <Col span={4}>
            <div className="time-request">
              {DateUtils.convertUTCToLocal(props.log.createdOn)}
            </div>
          </Col>
        </Row>
      </Link>
      <Modal
        title={"View Detail"}
        open={openModal}
        closable={false}
        footer={
          <button onClick={handleCloseModal}> {t('userMenu.close')}</button>
        }
        className="modal-log"
        width={700}>
        <div className="modal-body">
          <div className="modal-prop-title">
            <Avatar
              className="log-icon"
              size={40}
              src=""
              style={{ backgroundColor: '#4E46DC', marginRight: '7px' }}
              icon={<i className="icon-send"></i>}
            />
            <span className="title-prop">{props.log.transactionId}</span>
          </div>
          <div className="modal-content">
            <Row className="modal-prop">
              <Col
                span={6}
                className="name-prop">
                Sender
              </Col>
              <Col
                span={18}
                className="des-prop">
                {props.log.sender}
              </Col>
            </Row>
            <Row className="modal-prop">
              <Col
                span={6}
                className="name-prop">
                Receiver
              </Col>
              <Col
                span={18}
                className="des-prop">
                {props.log.receiver}
              </Col>
            </Row>
            {props.log.transactionType != undefined && (
              <Row className="modal-prop">
                <Col
                  span={6}
                  className="name-prop">
                  Transaction Type
                </Col>
                <Col
                  span={18}
                  className="des-prop">
                  {props.log.transactionType}
                </Col>
              </Row>
            )}
            <Row className="modal-prop">
              <Col
                span={6}
                className="name-prop">
                Action Time
              </Col>
              <Col
                span={18}
                className="des-prop">
                {DateUtils.convertUTCToLocal(props.log.createdOn)}
              </Col>
            </Row>
            <Row className="modal-prop">
              <Col
                span={6}
                className="name-prop">
                Status
              </Col>
              <Col
                span={18}
                className="des-prop">
                <Tag color={getColorByHttpMethod(props.log.logStatus)}>
                  {getLogStatusTitle(props.log.logStatus)}
                </Tag>
              </Col>
            </Row>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default TransactionLogComponent;
